import { MUITab } from "@abb/arcadia-ui-react"
import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import { BackToURL } from "../../../components/BackToURL"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { UserContext } from "../../../context/UserContext"
import { ObjectIds } from "../../../models/SupplierPortal"
import { useHashTab } from "../../../../hooks/useHashTab"
import { ObjectIdsDetails } from "./objectIds_details_tab/ObjectIdsDetails"

const returnURL = "/supplierPortal#object-id"

export function ObjectIdContainer() {
  const { objectIdsRequestId } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [oids, setOids] = useState<ObjectIds[]>()

  useEffect(() => {
    if (objectIdsRequestId) {
      digitalManagerApi
        .get<ObjectIds[]>(
          `/litePanelPro/objectIdsRequests/${objectIdsRequestId}/objectIds`
        )
        .then((res) => {
          setOids(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [objectIdsRequestId, navigate])

  if (!objectIdsRequestId) {
    return <Navigate to={returnURL} />
  }

  if (!oids || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  return (
    <div>
      <BackToURL url={returnURL} />
      <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <MUITab
          tabItems={[{ id: "details", label: "Details" }]}
          value={activeTab}
          handleChange={handleTabChange}
        />
        {activeTab === "details" && <ObjectIdsDetails objectIds={oids} />}
      </div>
    </div>
  )
}
